<template>
	<page enable-flex>
		<div class="head">
			<h5>{{productName || '-'}}</h5>
			<p>背贴码：{{codeInfo.produce_unique_code || '-'}}</p>
		</div>
		<c-tab-list ref="tab" :tabs="tabs" :immediate="false" @change="update"></c-tab-list>

		<template v-if="currentTab == 1">
			<view-list-card v-for="(item, i) in recordList" :key="i">
				<template #date>
					{{item.create_date}}
				</template>

				<template #total>
					<view-list-total name="维修金额" :value="'￥' + item.repair_amount"></view-list-total>
				</template>

				<template #default>
					<c-field label="维修项">{{item.repair_item_name}}</c-field>
					<c-field label="维修人">{{item.create_user_name}}</c-field>
					<c-field label="状态">{{item.repair_state == 2 ? '维修完成' : '维修中'}}</c-field>
				</template>

				<template #operate>
<!--					<c-link v-if="item.buttons?.complete_repair?.visible && auth('b_app_repair_record_complete')" icon="tf-finish" color="main" @click="recordCompleteHandle(item)">维修完成</c-link>-->
<!--					<c-link v-if="item.buttons?.edit_repair?.visible && auth('b_app_repair_record_edit')" icon="tf-edit" color="main" @click="mp.navigateWeb('/repair/record/edit', {id: item.id})">编辑</c-link>-->
<!--					<c-link v-if="item.buttons?.delete_repair?.visible && auth('b_app_repair_record_delete')" icon="tf-trash" color="red" @click="recordRemoveHandle(item)">删除</c-link>-->
					<c-link v-if="item.buttons?.view_repair_record?.visible && auth('b_app_repair_view')" icon="tf-search" color="main" @click="recordDetailHandle(item)">查看</c-link>
				</template>
			</view-list-card>
		</template>
		<template v-else>
			<view-list-card v-for="(item, i) in recordList" :key="i">
				<template #date>
					{{item.delivery_date}}
				</template>

				<template #total>
					<view-list-total name="维修金额" :value="'￥' + item.repair_amount"></view-list-total>
				</template>

				<template #default>
					<c-field label="维修单位">{{item.repair_unit}}</c-field>
					<c-field label="维修项">{{item.repair_item_name}}</c-field>
					<c-field label="送修人">{{item.sender_user_name}}</c-field>
					<c-field label="送修完成时间">{{item.complete_date || '-'}}</c-field>
				</template>

				<template #operate>
					<c-link v-if="item.buttons?.complete_delivery?.visible && auth('b_app_repair_delivery_complete')" icon="tf-finish" color="main" @click="mp.navigateWeb('/repair/finish', {code: item.produce_unique_code})">送修完成</c-link>
<!--					<c-link v-if="item.buttons?.delete_delivery?.visible && auth('b_app_repair_delivery_delete')" icon="tf-trash" color="red" @click="recordDeliveryHandle(item)">删除</c-link>-->
					<c-link v-if="item.buttons?.view_delivery?.visible && auth('b_app_repair_view')" icon="tf-search" color="main" @click="deliveryDetailHandle(item)">查看</c-link>
				</template>
			</view-list-card>
		</template>

		<c-empty v-if="!recordList.length" :message="currentTab == 1 ? '暂无维修记录' : '暂无送修记录'"></c-empty>

		<!--门店版没有维修工作台，新增入口就挂在记录页上；有接驳的版本仍从工作台添-->
		<template v-if="!hasHandover && codeInfo.produce_unique_code" #handle>
			<c-button v-if="auth('b_app_repair_record_create')" color="main" hollow prepend-icon="tf-add" @click="mp.navigateWeb('/repair/record/edit', {code: codeInfo.produce_unique_code})">添加维修记录</c-button>
		</template>
	</page>
</template>

<script>
	import {mapGetters} from 'vuex'

	export default {
		props: {
			code: [String, Number]
		},

		data() {
			return {
				codeInfo: {},
				tabs: [{
					name: '维修记录',
					value: 1
				}, {
					name: '送修记录',
					value: 2
				}],
				currentTab: 1,
				recordList: []
			}
		},

		computed: {
			/**是否接驳作业（门店版为false）：能力开关由服务端登录信息下发，端内不判版本编码*/
			...mapGetters(['hasHandover']),

			productName() {
				return [this.codeInfo.brand_name, this.codeInfo.model_name, this.codeInfo.color_name, this.codeInfo.memory_name].filter(item => item).join(' ');
			}
		},

		mounted() {
			this.request({
                url: '/productCode/queryByCode',
                data: {
					produce_unique_code: this.code
				},
				success: data => {
					this.codeInfo = data;
					this.$refs.tab.changeIndex(0);
				}
			});
			this.$onShow(() => {
				this.update();
			});
		},
		
		methods: {
			update(tab = {value: this.currentTab}) {
				this.currentTab = tab.value;
				this.recordList = [];
				this.request({
					url: this.currentTab == 1 ? '/repair/record/listByProduct' : '/repair/delivery/list',
					data: {
						produce_unique_code_id: this.codeInfo.id
					},
					success: data => {
						this.recordList = data;
					}
				});
			},

			/**维修记录详情：完成后本条记录冻结、编辑入口隐藏，看分项金额只能走这里*/
			recordDetailHandle(item) {
				this.globalDialog('repairRecordDetail', {
					props: {
						id: item.id
					}
				});
			},

			recordCompleteHandle(item) {
				this.$confirm({
					message: '完成后该维修记录不可再修改和删除，确认完成吗？',
					resolve: () => {
						this.request({
							url: '/repair/record/complete',
							data: {
								id: item.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '维修完成'
								});
								this.update();
							}
						});
					}
				});
			},
			
			recordRemoveHandle(item) {
				this.$confirm({
					message: '确认删除该维修记录吗？',
					resolve: () => {
						this.request({
							url: '/repair/record/delete',
							data: {
								id: item.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功'
								});
								this.update();
							}
						});
					}
				});
			},

			/**送修记录详情：送修完成后记录冻结，从这里看分项金额与备注*/
			deliveryDetailHandle(item) {
				this.globalDialog('repairDeliveryDetail', {
					props: {
						id: item.id
					}
				});
			},

			recordDeliveryHandle(item) {
				this.$confirm({
					message: '确认删除该送修记录吗？',
					resolve: () => {
						this.request({
							url: '/repair/delivery/delete',
							data: {
								id: item.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功'
								});
								this.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.head {
		padding: .26rem;
		font-size: .26rem;
		text-align: center;
		color: #fff;
		background: var(--color-main);

		h5 {
			margin-bottom: .2rem;
			font-size: .32rem;
		}
	}

	>>> .c-tab-list {
		margin-bottom: .2rem;

		ul {
			border: none;

			li {
				flex-grow: 1;

				&.z-crt {
					color: var(--color-main);
				}
			}
		}
	}

	>>> .card {
		margin-bottom: .24rem;
	}

	>>> .count {
		div {
			color: #FF6900;
		}
	}
</style>